import React from 'react';
import './aboutAuthor.css';
import authorPhoto from '../../assets/loubna.JPG'; 

function AboutAuthor() {
  return (
    <section className="about-author">
      <h2 className="author-title">About the Author</h2>
      <div className="author-content">
        <div className="author-image">
          <img src={authorPhoto} alt="Author" />
        </div>
        <div className="author-text">
          <p>
            Loubna is a software engineer who loves exploring both code and life. 
            Through writing, she shares insights, honesty, and lessons from her journey.
          </p>
          <p>
            She has been journaling since she was a child and turned this habit into books.
          </p>
          <p>
            She also loves music, movies, and of course, journaling.
          </p>
          
        </div>
      </div>
    </section>
  );
}

export default AboutAuthor;